import * as React from 'react';
import styled from "@emotion/styled";
export const BasicTray = styled.div`
		cursor: pointer;
		width:65%;
		margin: auto;
		margin-top:0.8em;
		margin-bottom:0.8em;
	`;
export class ItemWidgetIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return /*#__PURE__*/React.createElement(BasicTray, {
      title: this.props.title,
      color: this.props.color,
      draggable: true,
      onDragStart: event => {
        event.dataTransfer.setData('storm-graph_view-node', JSON.stringify(this.props.model));
      },
      onClick: e => {
        this.props.clickFunction(this.props.element, JSON.stringify(this.props.model), this.props.reduxProps);
      },
      className: "tray-item"
    }, this.props.children);
  }

}